export default __webpack_public_path__ + "static/media/Complete.b004c747.svg";